/**
 * The two shapes of the Orders tab's address: the list (/asoebi/orders) and
 * one order's page (/asoebi/orders/new, /asoebi/orders/<ref>). AsoebiManager
 * uses this to decide which screen to mount; GuestAsoebiTracker uses it to
 * read which order the address names, so the two cannot disagree.
 */
export const ASOEBI_ORDERS_PATH = '/asoebi/orders';
export const ASOEBI_ORDER_NEW_PATH = '/asoebi/orders/new';

const DETAIL = /^\/asoebi\/orders\/([^/]+)$/;

/** 'new' or the order reference segment when the path is an order's own page; null for the list and for any other path. */
export function orderDetailSegment(pathname: string): string | null {
  const match = DETAIL.exec(pathname);
  return match ? match[1] : null;
}

/** True on /asoebi/orders/new and /asoebi/orders/<ref>. */
export const isAsoebiOrderDetailUrl = (pathname: string): boolean => orderDetailSegment(pathname) !== null;

/** True on the list itself (a trailing slash counts). */
export const isAsoebiOrdersListUrl = (pathname: string): boolean =>
  pathname === ASOEBI_ORDERS_PATH || pathname === `${ASOEBI_ORDERS_PATH}/`;
